import { CompanyClients, type ClientRowAddon } from '../modules/clients/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ClientsView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyClientsScreen({
  view,
  onView,
  onOpenClient,
  rowAddon,
}: {
  view: ClientsView;
  rowAddon?: ClientRowAddon | undefined;
  onOpenClient: (clientId: string) => void;
  onView: ViewSetter<ClientsView>;
}) {
  const { can, timeZone, today } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('clients.read')}>
      <CompanyClients
        capabilities={{
          canCreate: can('clients.create'),
          canUpdate: can('clients.update'),
          canArchive: can('clients.delete'),
          canManageAccess: can('clients.access.manage'),
        }}
        timeZone={timeZone}
        today={today}
        view={view}
        onView={onView}
        onOpenClient={onOpenClient}
        rowAddon={rowAddon}
      />
    </GatedCompanyScreen>
  );
}
